import Header from "./Header/Header";
import Footer from "./Footer/Footer";

const PublicLayout = ({ children }) => {
  return (
    <div className="portal-page">
      <Header />

      <main style={{ paddingTop: "68px", minHeight: "100vh" }}>
        {children}
      </main>

      <Footer />
    </div>
  );
};

export default PublicLayout;